<!-- Component can only be used in microscope, contains tailwind -->
<template>
  <AppCard class="w-full box-border rounded-xl p-6">
    <img class="mx-auto block" :src="bankIdLogoSrc" :alt="bankIdLogoAlt" height="225" />

    <slot name="above-button" />

    <AppButton :loading="loading" block large @click="emit('start')">
      {{ loading ? 'Startar...' : buttonText }}
    </AppButton>
  </AppCard>
</template>

<script setup lang="ts">
import AppButton from '../AppButton/AppButton.vue'
import AppCard from '../AppCard/AppCard.vue'

defineProps<{
  loading?: boolean
  buttonText?: string
  bankIdLogoSrc: string
  bankIdLogoAlt?: string
}>()

const emit = defineEmits<{
  (e: 'start'): void
}>()
</script>
